import { Link } from "react-router-dom";
import { Star, Pencil, GraduationCap, Copy, Trash2, Printer } from "lucide-react";
import { PlayCanvas } from "@/components/field/PlayCanvas";
import { catLabel } from "@/components/PlayFilters";

export function PlayCard({ play, team, learnTo, editTo, printTo, onFavorite, onDuplicate, onDelete }) {
  return (
    <article className="card overflow-hidden flex flex-col tpc-rise" data-testid={`play-card-${play.id}`}>
      <Link to={learnTo} className="block" aria-label={`Open ${play.name}`}>
        <PlayCanvas play={play} team={team} />
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-wider text-[#FF8A1F]">{catLabel(play.category)}{play.formation && ` · ${play.formation}`}</p>
            <h3 className="font-display text-xl font-bold uppercase leading-tight truncate" data-testid="play-card-name">{play.name}</h3>
          </div>
          {onFavorite && (
            <button onClick={onFavorite} className="btn px-2 text-[#FACC15]" aria-label={play.favorite ? "Remove favorite" : "Add favorite"} aria-pressed={play.favorite} data-testid={`btn-favorite-${play.id}`}>
              <Star size={22} fill={play.favorite ? "currentColor" : "none"} />
            </button>
          )}
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {play.is_example && <span className="text-[10px] font-extrabold uppercase px-2 py-0.5 rounded bg-[#FACC15] text-[#0B1528]" data-testid="badge-example">Example — adapt it</span>}
          {play.tags.filter((t) => t !== "Example").map((t) => <span key={t} className="text-[11px] text-slate-400">#{t}</span>)}
        </div>
        <div className="flex flex-wrap gap-2 mt-auto pt-4">
          <Link to={learnTo} className="btn btn-primary flex-1" data-testid={`btn-learn-${play.id}`}><GraduationCap size={18} />Learn</Link>
          {editTo && <Link to={editTo} className="btn btn-ghost" data-testid={`btn-edit-${play.id}`}><Pencil size={16} />Edit</Link>}
          {onDuplicate && <button onClick={onDuplicate} className="btn btn-ghost px-3" aria-label="Duplicate" data-testid={`btn-duplicate-${play.id}`}><Copy size={16} /></button>}
          {printTo && <Link to={printTo} className="btn btn-ghost px-3" aria-label="Print" data-testid={`btn-print-${play.id}`}><Printer size={16} /></Link>}
          {onDelete && <button onClick={onDelete} className="btn btn-danger px-3" aria-label="Delete" data-testid={`btn-delete-${play.id}`}><Trash2 size={16} /></button>}
        </div>
      </div>
    </article>
  );
}
